import { useTranslation } from "react-i18next";
import {Consts} from "../pages/consts";
import {useState} from "react";
import {getInputFocusStyle} from "../pages/utils";

const PgxHeader = ({ newPgx, setNewPgx, init = true, createNewDialogOpened= false }) => {
  const { t } = useTranslation();
  const [isTextFieldFocused, setIsTextFieldFocused] = useState(false);

  return (
    <form
      className={
        init
          ? "w3-container form-panel"
          : "w3-container w3-margin-bottom w3-left-align"
      }
    >
      <div className="w3-row w3-padding-small" style={{textAlign: "left"}}>
        <label>{t("laboratory_name")}{ createNewDialogOpened ? '*:' : ':' }</label>
        {
          createNewDialogOpened
            ?
            <input
              name={Consts.LAB}
              type={Consts.TEXT}
              onFocus={() => setIsTextFieldFocused(true)}
              onBlur={() => setIsTextFieldFocused(false)}
              className="w3-input w3-border w3-round form-input"
              onChange={(event) => setNewPgx({ ...newPgx, labName: event.target.value })}
              defaultValue={newPgx?.labName}
              style={getInputFocusStyle(isTextFieldFocused)}
            />
            :
            <label className="w3-margin-left">{newPgx?.labName}</label>
        }
      </div>
      <div className="w3-row w3-padding-small" style={{textAlign: "left"}}>
        <label>{t("test_date")}{ createNewDialogOpened ? '*:' : ':' }</label>
        {
          createNewDialogOpened
            ?
            <input
              name="date"
              type="date"
              className="w3-input w3-border w3-round form-input"
              onChange={(event) => setNewPgx({ ...newPgx, testDate: event.target.value })}
              defaultValue={newPgx?.testDate}
            />
            :
            <label className="w3-margin-left">{newPgx?.testDate}</label>
        }
      </div>
    </form>
  );
};

export default PgxHeader;
